class LqdCurtainHandler extends elementorModules.frontend.handlers.Base {

	onInit( ...args ) {

		super.onInit( ...args );

		this.handleDestroy();

		this.initCurtain();

	}

	getDefaultSettings() {
		return {
			selectors: {
				curtainEl: '[data-lqd-curtain]',
			}
		}
	}

	getDefaultElements() {
		const selectors = this.getSettings( 'selectors' );
		return {
			$curtainEl: this.$element.find( selectors.curtainEl ),
		}
	}

	initCurtain() {

		this.elements.$curtainEl.liquidCurtain();

	}

	onDestroy() {

		this.handleDestroy();

		super.onDestroy();

	}

	handleDestroy() {

		this.handleCurtainDestroy();

	}

	handleCurtainDestroy() {

		if ( !this.elements.$curtainEl.length ) return;

		const curtainData = this.elements.$curtainEl.data( 'plugin_liquidCurtain' );

		if ( curtainData ) {
			curtainData.destroy();
		}

	}

}

export default ( $element ) => {
	elementorFrontend.elementsHandler.addHandler( LqdCurtainHandler, { $element } );
};